module.exports = __webpack_public_path__ + "public/img/640 (5).9e1c78da.gif";